var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteview(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_179)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_35_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6194 9.91178C17.9419 9.91178 19.8247 8.02874 19.8247 5.70589C19.8247 3.38304 17.9419 1.5 15.6194 1.5C13.2969 1.5 11.4141 3.38304 11.4141 5.70589C11.4141 8.02874 13.2969 9.91178 15.6194 9.91178Z",
    stroke: "#9575CD",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8269 23.5C18.3109 23.5 15.945 23.5 15.945 23.5M15.945 23.5H4.65385C4.06424 23.5 3.54917 23.1014 3.40122 22.5306L1.8077 16.3834C1.59529 15.564 2.21384 14.7646 3.06033 14.7646H12.3908C12.9639 14.7646 13.4688 15.1416 13.6316 15.6911L15.945 23.5Z",
    stroke: "#9575CD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47852 15.5V14.441C9.47852 12.6543 10.9269 11.2059 12.7136 11.2059H18.5359C20.3226 11.2059 21.771 12.6543 21.771 14.441V17.6767C21.771 19.4634 20.3226 20.9118 18.5359 20.9118H14.5",
    stroke: "#9575CD",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5354 14.7648C18.5354 16.1942 17.3766 17.353 15.9472 17.353H14.3301",
    stroke: "#9575CD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_35_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteview);
export default __webpack_public_path__ + "static/media/inteview.3d9236cb16be9324d56daef33e49df90.svg";
export { ForwardRef as ReactComponent };